import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import 'bootstrap/dist/css/bootstrap.min.css'
import './index.css'
import './assets/css/custom.css'

// Error boundary (dev only, generic message)
if (import.meta.env.MODE !== 'production') {
    window.addEventListener('error', function() {
        // dev-only: avoid logging sensitive data
    });
}

ReactDOM.createRoot(document.getElementById('app')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
